// extracted by mini-css-extract-plugin
export default {"providerCardContainer":"providerList_providerCardContainer__HNTOE"};